






















































import { computed, defineComponent } from '@nuxtjs/composition-api'
import { useDep } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'

export default defineComponent({
  setup() {
    const legacyUrlService = useDep(LegacyUrlService)

    const creditsUrl = computed(() => {
      return legacyUrlService.getBuyCreditsUrl()
    })

    return {
      creditsUrl
    }
  }
})
